
import {
    FaTooth,
    FaSmile,
    FaUserMd,
    FaClinicMedical,
    FaLeaf,
    FaChild,
} from "react-icons/fa";
import service01 from '../assets/s01.jpeg';
import service02 from '../assets/s02.jpeg';
import service03 from '../assets/s03.jpeg';
import service04 from '../assets/s04.jpeg';
import service05 from '../assets/s05.jpeg';
import service06 from '../assets/s06.jpeg';
import imgs01 from '../assets/img1.png';
import imgs02 from '../assets/img2.png';
import imgs03 from '../assets/img3.png';
import imgs04 from '../assets/img4.png';
import imgs05 from '../assets/img5.png';
import imgs06 from '../assets/imgs06.jpg';

import paro from '../assets/parodontologie.jpg'; 
import esthetique from '../assets/esthetique.jpg'; 

import imgEnfant from '../assets/imgEnfant.webp';
import canvaimg1 from '../assets/1.jpg';
import canvaimg2 from '../assets/2.jpg';
import canvaimg3 from '../assets/3.jpg';

export const services = [
    {
        id: 1,
        icon: <FaTooth className="w-10 h-10 text-white mb-4" />,
        title: "Examen Dentaire",
        description:
            "Préservez la santé de vos dents grâce à des traitements adaptés aux caries et autres affections.",
        bgImage: `url('${imgs01}')`,
    },
    {
        id: 2,
        icon: <FaSmile className="w-10 h-10 text-white mb-4" />,
        title: "Blanchiment Dentaire",
        description:
            "Procédure dentaire visant à éclaircir la couleur des dents et à éliminer les taches et les décolorations.",
        bgImage: `url('${imgs02}')`,
    },
    {
        id: 3,
        icon: <FaClinicMedical className="w-10 h-10 text-white mb-4" />,
        title: "Prothèse dentaire",
        description:
            "Retrouvez une fonction dentaire optimale grâce à nos prothèses sur mesure.",
        bgImage: `url('${imgs03}')`,
    },
    {
        id: 4,
        icon: <FaLeaf className="w-10 h-10 text-white mb-4" />,
        title: "Esthétique Dentaire",
        description:
            "Restauration dentaire utilisée pour remplacer des dents manquantes ou endommagées.",
        bgImage: `url('${imgs04}')`,
    },
    {
        id: 5,
        icon: <FaUserMd className="w-10 h-10 text-white mb-4" />,
        title: "Plombage Dentaire",
        description:
            "Procédure utilisée pour réparer une dent endommagée par une carie ou d'autres types de dommages.",
        bgImage: `url('${imgs05}')`,
    },
    {
        id: 6,
        icon: <FaChild className="w-10 h-10 text-white mb-4" />,
        title: "Dentisterie Esthétique",
        description:
            "Procédures dentaires conçues pour améliorer l'apparence des dents, des gencives et du sourire.",
        bgImage: `url('${imgs06}')`,
    },
];



export const list_services_page = [
    {
        id: 1,
        icon: <FaSmile className="w-10 h-10 text-white mb-4" />,
        title: "Dentisterie Esthétique",
        description:
            "Procédures dentaires conçues pour améliorer l'apparence des dents, des gencives et du sourire, notamment le blanchiment dentaire, les facettes dentaires, et la restauration de dents.",
        steps: [
            "Consultation",
            "Planification des soins",
            "Préparation des dents",
            "Application des traitements esthétiques",
            "Évaluation des résultats",
        ],
        article:
            "Les traitements incluent le blanchiment dentaire pour éclaircir les dents, les facettes dentaires pour corriger leur apparence, et la restauration pour améliorer l'esthétique et la fonctionnalité. Le processus commence par une consultation, suivie d'une planification et d'une préparation avant les soins.",
        imagePath: imgs05,
        // imagePath: service01,
    },
    {
        id: 2,
        icon: <FaTooth className="w-10 h-10 text-white mb-4" />,
        title: "Endodontie et Restauration Dentaire/Prothèses",
        description:
            "Traitements pour restaurer les dents endommagées, notamment le traitement de canal, le retraitement endodontique, les plombages et les couronnes dentaires.",
        steps: [
            "Diagnostic et consultation",
            "Planification du traitement",
            "Préparation de la dent",
            "Traitement de canal ou réparation",
            "Placement de prothèses ou obturation",
            "Évaluation post-traitement",
        ],
        article:
            "Ces procédures visent à traiter les infections internes des dents avec un traitement de canal ou un retraitement endodontique. Les plombages et couronnes complètent la restauration, rendant les dents fonctionnelles et esthétiques.",
        imagePath: imgs02,
    },
    {
        id: 3,
        icon: <FaClinicMedical className="w-10 h-10 text-white mb-4" />,
        title: "Implantologie",
        description:
            "Remplacement des dents manquantes avec des implants dentaires unitaires, multiples, ou la méthode All-on-4 pour un remplacement complet.",
        steps: [
            "Consultation et planification",
            "Analyse radiologique",
            "Pose chirurgicale des implants",
            "Phase de cicatrisation",
            "Placement des prothèses",
            "Évaluation des résultats",
        ],
        article:
            "Les implants offrent une solution durable pour les dents manquantes. Les options incluent des implants unitaires pour une seule dent, multiples pour plusieurs dents, et All-on-4 pour restaurer une arcade complète.",
        imagePath: imgs04,
    },
    {
        id: 4,
        icon: <FaChild className="w-10 h-10 text-white mb-4" />,
        title: "Pédodontie",
        description:
            "Soins dentaires spécialisés pour les enfants, comprenant des examens dentaires et le traitement des caries.",
        steps: [
            "Consultation adaptée aux enfants",
            "Examen dentaire",
            "Identification des caries",
            "Planification du traitement",
            "Application des soins",
            "Suivi régulier",
        ],
        article:
            "La pédodontie vise à instaurer une bonne santé dentaire chez les enfants. Les examens permettent de détecter les caries et d'intervenir tôt pour garantir des dents saines et un sourire confiant.",
        imagePath: imgs03,
    },
    {
        id: 5,
        icon: <FaLeaf className="w-10 h-10 text-white mb-4" />,
        title: "Parodontologie",
        description:
            "Traitement des maladies des gencives et des tissus de soutien des dents, notamment le détartrage et le surfaçage ainsi que le traitement de la gingivite et de la parodontite.",
        steps: [
            "Diagnostic des gencives",
            "Nettoyage en profondeur",
            "Surfaçage des racines",
            "Planification du traitement",
            "Application des soins spécifiques",
            "Suivi pour prévenir les récidives",
        ],
        article:
            "La parodontologie se concentre sur le traitement des maladies des gencives telles que la gingivite et la parodontite. Le détartrage et le surfaçage aident à éliminer la plaque et à améliorer la santé gingivale.",
        imagePath: imgs01,
    },
];
